import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

// Component to display a contact item
const ContactItem = ({ contact, matchedUser, onSendRequest, loading, hasBeenInvited = false }) => {
  if (matchedUser) {
    // User found on Disgo
    const getButtonContent = () => {
      switch (matchedUser.relationshipStatus) {
        case 'friends':
          return {
            text: 'Friends',
            icon: 'checkmark-circle',
            color: '#5E3D2D',
            disabled: true,
          };
        case 'requestSent':
          return {
            text: 'Pending',
            icon: 'time',
            color: '#9C6B42',
            disabled: true,
          };
        default:
          if (matchedUser.hasBeenInvited) {
            return {
              text: 'Invited',
              icon: 'mail',
              color: '#9E9E9E',
              disabled: true,
            };
          }
          return {
            text: 'Add Friend',
            icon: 'person-add',
            color: '#F9F5F3',
            disabled: false,
          };
      }
    };

    const buttonContent = getButtonContent();

    return (
      <View style={styles.container}>
        <View style={styles.contactInfo}>
          <View style={styles.avatarContainer}>
            {matchedUser.pfpUrl ? (
              <Image source={{ uri: matchedUser.pfpUrl }} style={styles.avatar} />
            ) : (
              <View style={styles.defaultAvatar}>
                <Ionicons name="person" size={24} color="#666" />
              </View>
            )}
          </View>
          <View style={styles.textContainer}>
            <Text style={styles.name}>{contact.name || 'Unknown Contact'}</Text>
            <Text style={styles.username}>@{matchedUser.username}</Text>
            <View style={styles.contactInfo}>
              {contact.phoneNumbers?.[0]?.number && (
                <Text style={styles.contactDetail}>
                  <Ionicons name="call" size={12} color="#666" /> {contact.phoneNumbers[0].number}
                </Text>
              )}
            </View>

          </View>
        </View>
        
        <TouchableOpacity
          style={[
            styles.button,
            { backgroundColor: buttonContent.color },
            buttonContent.disabled && styles.disabledButton
          ]}
          onPress={() => onSendRequest(matchedUser)}
          disabled={loading || buttonContent.disabled}
        >
          <Ionicons 
            name={buttonContent.icon} 
            size={16} 
            color={buttonContent.color === '#F9F5F3' ? '#4e2916' : 'white'} 
          />
          <Text style={[
            styles.buttonText,
            { color: buttonContent.color === '#F9F5F3' ? '#4e2916' : 'white' }
          ]}>
            {buttonContent.text}
          </Text>
        </TouchableOpacity>
      </View>
    );
  }

  // No user found on Disgo
  return (
    <View style={styles.container}>
      <View style={styles.contactInfo}>
        <View style={styles.avatarContainer}>
          <View style={styles.defaultAvatar}>
            <Ionicons name="person" size={24} color="#666" />
          </View>
        </View>
        <View style={styles.textContainer}>
          <Text style={styles.name}>{contact.name || 'Unknown Contact'}</Text>
                      <View style={styles.contactInfo}>
              {contact.phoneNumbers?.[0]?.number ? (
                <Text style={styles.contactDetail}>
                  <Ionicons name="call" size={12} color="#666" /> {contact.phoneNumbers[0].number}
                </Text>
              ) : (
                <Text style={styles.contactDetail}>No phone number</Text>
              )}
            </View>

        </View>
      </View>
      
      <TouchableOpacity
        style={[
          styles.button, 
          styles.inviteButton,
          hasBeenInvited && styles.disabledButton
        ]}
        onPress={() => onSendRequest({
          name: contact.name || 'Unknown Contact',
          phoneNumber: contact.phoneNumbers?.[0]?.number || "",
          email: contact.emails?.[0]?.email || ""
        })}
        disabled={loading || hasBeenInvited}
      >
        <Ionicons name={hasBeenInvited ? "checkmark" : "mail"} size={16} color="white" />
        <Text style={styles.buttonText}>{hasBeenInvited ? "Invited" : "Invite"}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  contactInfo: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatarContainer: {
    marginRight: 12,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
  defaultAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#f0f0f0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    flex: 1,
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  username: {
    fontSize: 14,
    color: '#666',
    marginBottom: 2,
  },
  contactEmail: {
    fontSize: 12,
    color: '#999',
    marginBottom: 4,
  },
  contactInfo: {
    marginBottom: 4,
  },
  contactDetail: {
    fontSize: 12,
    color: '#999',
    marginBottom: 2,
    flexDirection: 'row',
    alignItems: 'center',
  },

  button: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    minWidth: 100,
    justifyContent: 'center',
    marginLeft: 16,
  },
  buttonText: {
    color: '#000000',
    fontSize: 14,
    fontWeight: '600',
    marginLeft: 6,
  },
  disabledButton: {
    opacity: 0.6,
  },
  inviteButton: {
    backgroundColor: '#999',
  },
});

export default ContactItem;
